import { createSelector } from 'reselect'

export const getWasSentSms = createSelector(
  state => Boolean(state && state.ads && state.ads.add && state.ads.add.wasSentSms),
  wasSent => wasSent
)
